import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export function useLeadsParaTarefa(props: QueryGlobalInterface) {
  const fetchData = async () => {
    const LEAD_PARA_TAREFA = `${leadsWebEnviroment}/commom/leads/leads-para-tarefa/v1`;
    const response = await instance.get(LEAD_PARA_TAREFA);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    cacheTime: 0,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar leads para tarefa. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
